var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (i18n, id, listTitle, sales) {
      pug_mixins["icon"] = pug_interp = function(iconId, extraClassnames=''){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg" + (pug.attr("class", pug.classes(["icon",(extraClassnames !== '') ? extraClassnames : false], [false,true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003Cuse" + (pug.attr("xlink:href", `#${iconId}`, true, true)) + "\u002F\u003E\u003C\u002Fsvg\u003E";
};
pug_html = pug_html + "\u003Ch3 class=\"fs-6 mb-fixed-16 mb-fixed-lg-32 pt-fixed-lg-16 text-center lh-1\"\u003E" + (null == (pug_interp = listTitle) ? "" : pug_interp) + "\u003C\u002Fh3\u003E";
if (sales && sales.length > 0) {
// iterate sales
;(function(){
  var $$obj = sales;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var person = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle class=\"bg-white shadow-sm border rounded-4 mb-fixed-8 p-fixed-16 p-fixed-lg-24 p-fixed-xl-32\"\u003E\u003Ch4 class=\"fs-5 mb-fixed-16 text-secondary d-flex align-items-center\"\u003E";
pug_mixins["icon"]('icon-person', 'icon-lg me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cspan class=\"text-dark\"\u003E" + (pug.escape(null == (pug_interp = person.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Cdiv class=\"cms-content fs-small\"\u003E";
if (person.description) {
pug_html = pug_html + (null == (pug_interp = person.description) ? "" : pug_interp);
}
if (person.phone || person.fax || person.email) {
pug_html = pug_html + "\u003Cul class=\"list-unstyled\"\u003E";
if (person.phone) {
pug_html = pug_html + "\u003Cli class=\"d-flex align-items-center text-primary mb-1\"\u003E";
pug_mixins["icon"]('icon-phone', 'icon-sm me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cstrong class=\"text-dark me-1\"\u003E" + (pug.escape(null == (pug_interp = i18n.phone_label) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Cspan class=\"text-dark\"\u003E" + (pug.escape(null == (pug_interp = person.phone) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
}
if (person.fax) {
pug_html = pug_html + "\u003Cli class=\"d-flex align-items-center text-primary mb-1\"\u003E";
pug_mixins["icon"]('icon-phone', 'icon-sm me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cstrong class=\"text-dark me-1\"\u003E" + (pug.escape(null == (pug_interp = i18n.fax_label) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Cspan class=\"text-dark\"\u003E" + (pug.escape(null == (pug_interp = person.fax) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
}
if (person.email) {
pug_html = pug_html + "\u003Cli class=\"d-flex flex-wrap align-items-center text-primary mb-1\"\u003E";
pug_mixins["icon"]('icon-envelope', 'icon-sm me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cstrong class=\"text-dark me-1\"\u003E" + (pug.escape(null == (pug_interp = i18n.email_label) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Ca" + (" class=\"link-dark text-decoration-none mw-100 overflow-wrap-break-word\""+pug.attr("href", `mailto:${person.email}`, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = person.email) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var person = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle class=\"bg-white shadow-sm border rounded-4 mb-fixed-8 p-fixed-16 p-fixed-lg-24 p-fixed-xl-32\"\u003E\u003Ch4 class=\"fs-5 mb-fixed-16 text-secondary d-flex align-items-center\"\u003E";
pug_mixins["icon"]('icon-person', 'icon-lg me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cspan class=\"text-dark\"\u003E" + (pug.escape(null == (pug_interp = person.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fh4\u003E\u003Cdiv class=\"cms-content fs-small\"\u003E";
if (person.description) {
pug_html = pug_html + (null == (pug_interp = person.description) ? "" : pug_interp);
}
if (person.phone || person.fax || person.email) {
pug_html = pug_html + "\u003Cul class=\"list-unstyled\"\u003E";
if (person.phone) {
pug_html = pug_html + "\u003Cli class=\"d-flex align-items-center text-primary mb-1\"\u003E";
pug_mixins["icon"]('icon-phone', 'icon-sm me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cstrong class=\"text-dark me-1\"\u003E" + (pug.escape(null == (pug_interp = i18n.phone_label) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Cspan class=\"text-dark\"\u003E" + (pug.escape(null == (pug_interp = person.phone) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
}
if (person.fax) {
pug_html = pug_html + "\u003Cli class=\"d-flex align-items-center text-primary mb-1\"\u003E";
pug_mixins["icon"]('icon-phone', 'icon-sm me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cstrong class=\"text-dark me-1\"\u003E" + (pug.escape(null == (pug_interp = i18n.fax_label) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Cspan class=\"text-dark\"\u003E" + (pug.escape(null == (pug_interp = person.fax) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
}
if (person.email) {
pug_html = pug_html + "\u003Cli class=\"d-flex flex-wrap align-items-center text-primary mb-1\"\u003E";
pug_mixins["icon"]('icon-envelope', 'icon-sm me-2 flex-shrink-0');
pug_html = pug_html + "\u003Cstrong class=\"text-dark me-1\"\u003E" + (pug.escape(null == (pug_interp = i18n.email_label) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Ca" + (" class=\"link-dark text-decoration-none mw-100 overflow-wrap-break-word\""+pug.attr("href", `mailto:${person.email}`, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = person.email) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E";
    }
  }
}).call(this);

}
else {
pug_html = pug_html + "\u003Cdiv class=\"bg-white shadow-sm border rounded-1 mb-fixed-8 p-fixed-8 p-fixed-lg-16 cms-content\"\u003E\u003Cp\u003E";
if (typeof id !== 'undefined' && id) {
pug_html = pug_html + (null == (pug_interp = i18n.not_found_filtered) ? "" : pug_interp);
}
else {
pug_html = pug_html + (null == (pug_interp = i18n.not_found) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
    }.call(this, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "listTitle" in locals_for_with ?
        locals_for_with.listTitle :
        typeof listTitle !== 'undefined' ? listTitle : undefined, "sales" in locals_for_with ?
        locals_for_with.sales :
        typeof sales !== 'undefined' ? sales : undefined));
    ;;return pug_html;}

module.exports = template